import validate from "/app/node_modules/.pnpm/nuxt@3.17.5_@biomejs+biome@1.9.4_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node_29940a95070cde5beb11c84a187319fe/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.5_@biomejs+biome@1.9.4_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node_29940a95070cde5beb11c84a187319fe/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}